module.exports = __webpack_public_path__ + "img/qr-code.7786f287.png";